import parse from 'json-to-ast';
export function getAstByString(jsonString, json) {
    const jsonAST = parse(jsonString, { loc: true });
    return {
        json: json || JSON.parse(jsonString),
        jsonString,
        jsonAST,
    };
}
export function getAstByObject(json, indent = 4) {
    var _a;
    const jsonString = JSON.stringify(json !== null && json !== void 0 ? json : null, null, indent);
    const ret = getAstByString(jsonString);
    // When we get undefined as input, mimic null behavior
    if (json === undefined) {
        const jsonAST = ret.jsonAST;
        // istanbul ignore next
        if ((_a = jsonAST.loc) === null || _a === void 0 ? void 0 : _a.end) {
            jsonAST.loc.end.column += 5;
            jsonAST.loc.end.offset += 5;
            jsonAST.loc.source = undefined;
        }
        jsonAST.value = undefined;
        jsonAST.raw = 'undefined';
        ret.jsonString = 'undefined';
        ret.json = undefined;
    }
    return ret;
}
